<template>
  <div class="font-semibold mb-1 mt-6">
    {{ getLocalizedEventValue(eventItem, locale, 'info1') }}
  </div>

  <div class="text-xs text-text flex gap-1 md:gap-4 flex-col md:flex-row">
    <EventDate :event="props.eventItem" :showTime="true"/>
    <div>
         <!-- {{ getAddressStringFromLocation(event.location) }} TODO get the address string from venue object --> 
    </div>
  </div>
</template>

<script setup lang="ts">
// TODO get event id (or a ref) as a "parameter" for this component (or just the individual values needed)
  // import { getAddressStringFromLocation } from '@/utils/getAddressStringFromLocation';

  import { useI18n } from 'vue-i18n';

  import type { EventItem } from '@/types';
  import { getLocalizedEventValue } from '@/utils/eventItemUtil';

  import EventDate from '../event/EventDate.vue';
  const props = defineProps<{
    eventItem: EventItem;
  }>();

  const { locale } = useI18n();

</script>
